<!--
  修改密码
  @see card-mobile-bind.vue
-->

<template>
  <div style="height: 100%;background-color: #f7f8fa">
    <van-cell-group>
      <van-field v-model.trim="code" label="短信验证码" placeholder="请输入手机收到的验证码">
        <van-button v-show="isVisibleCode" slot="button" round size="mini" type="info" @click="codeClick">
          发送验证码
        </van-button>
        <van-button v-show="!isVisibleCode" slot="button" disabled size="small" type="info">
          {{ disabledCodeText }}秒后重新获取
        </van-button>
      </van-field>
      <van-field :value="payPwd" clickable label="支付密码" placeholder="请输入6位数字密码" readonly type="password"
        @touchstart.native.stop="payPwdShow = true; payPwdOkShow = false" />
      <van-number-keyboard v-model="payPwd" :maxlength="6" :show="payPwdShow" @blur="payPwdShow = false" />
      <van-field :value="payPwdOk" clickable label="确认密码" placeholder="请输入6位数字密码" readonly type="password"
        @touchstart.native.stop="payPwdOkShow = true; payPwdShow = false" />
      <van-number-keyboard v-model="payPwdOk" :maxlength="6" :show="payPwdOkShow" @blur="payPwdOkShow = false" />
    </van-cell-group>
    <div style="margin: 16px;">
      <van-button block class="login-btn" round type="info" @click="nextClick">下一步</van-button>
    </div>

    <div style="text-align: center;width: 100%;position: absolute;bottom: 100px">
      <router-link style="text-align: center" to="user-center-help">无法收到短信?</router-link>
    </div>
    <div style="text-align: center;width: 100%;position: absolute;bottom: 50px">
      <router-link style="text-align: center" to="card-mobile-bind">没有绑定手机?</router-link>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { send_validate_code_sms, validateSmsCode } from '@/api/user'

export default {
  name: "update-pwd",

  data() {
    return {
      code: '',
      cardPwd: '',
      payPwd: '',
      payPwdShow: false,
      payPwdOk: '',
      payPwdOkShow: false,
      payPwd2: '',
      isVisibleCode: true,
      disabledCodeText: '',
      time: 120,
    }
  },

  methods: {
    // 点击发送验证码
    codeClick() {
      this.isVisibleCode = false
      this.getTime()
      send_validate_code_sms(this.$store.getters.userInfo.mobile)
    },

    nextClick() {
      if (this.code === '') {
        Toast({ message: '请输入手机收到的验证码', duration: 1000 })
        return
      }

      if (this.payPwd === '') {
        Toast({ message: '密码不能为空', duration: 1000 })
        return
      }

      if (this.payPwd !== this.payPwdOk) {
        Toast({ message: '两次输入密码不一致', duration: 1000 })
        return
      }

      validateSmsCode('000', this.code, this.payPwd).then(res => {
        if (res.code === 0) {
          this.$store.dispatch('store_get_user_info').then(() => {
            Toast({
              message: '密码修改成功',
              duration: 2000
            })
            this.$router.go(-1)
          })
        } else {
          Toast(res.msg || '验证码错误 C')
        }
      })
    },

    // 倒计时
    getTime() {
      this.time--
      this.disabledCodeText = this.time
      if (this.time === 0) {
        this.isVisibleCode = true
        this.time = 120
        return
      }

      setTimeout(() => {
        this.getTime()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped></style>
